import TimeAgo from 'timeago-react'
import { useAppLanguage } from 'i18n/useAppLanguage'

export default function LocalizedTimeAgo(props) {
  const { currentLanguage } = useAppLanguage()

  return <TimeAgo {...props} locale={currentLanguage === 'es' ? 'es' : 'en_US'} />
}
